import * as types from './ActionsNavigation';

export default function navigationReducer(
    state = {
        actualView: decodeURI(window.location.pathname),
        backShown: false,
        navigation: false
    }, action: any) {
    switch (action.type) {
        case types.NAVIGATION_TOGGLE:
            state.navigation = action.value;
            break;
        case types.NAVIGATION_UPDATEVIEW:
            state.actualView = action.value;
            state.navigation = false;
            state.backShown = (action.value.includes("Afficher") || action.value.includes("Créer") || action.value.includes("Modifier") || action.value.includes("Stock"));
            break;
    }

    return { ...state };
}



// WEBPACK FOOTER //
// ./src/app/stores/reducers/navigation/NavigationReducer.ts